'use client';
import * as React from 'react';
import type { Transition } from 'framer-motion';
import { motion, useAnimation } from 'framer-motion';

const defaultTransition: Transition = {
	type: 'spring',
	stiffness: 160,
	damping: 17,
	mass: 1,
};

interface IconProps {
	isHovered: boolean;
}

export function LogoutIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<path d='M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4' />
				<motion.polyline
					points='16 17 21 12 16 7'
					variants={{
						animate: { x: 3, opacity: 1 },
						normal: { x: 0, opacity: 1 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
				<motion.line
					x1='21'
					x2='9'
					y1='12'
					y2='12'
					variants={{
						animate: { x: 3, opacity: 1 },
						normal: { x: 0, opacity: 1 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
			</svg>
		</div>
	);
}
